<app-important-notice></app-important-notice>
<router-outlet></router-outlet>
<app-privacy-notice></app-privacy-notice>
